import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl} from '@angular/platform-browser';

type SafeType = 'html' | 'url';

@Pipe({
  name: 'safeElement',
  standalone: false,
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, safeType: SafeType): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (safeType) {
      case 'html': {
        return this.sanitizer.bypassSecurityTrustHtml(value);
      }
      case 'url': {
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      }
      default:
        throw new Error(`Invalid safe type specified: ${safeType}`);
    }
  }
}
